module.exports = __webpack_public_path__ + "assets/img/form2.0492a546.png";